import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { apiClient, extractApiError } from '../api/axios';
import { API } from '../constants/api';

const initialState = {
  // Live recipients count (shown next to the filter in the SMS form).
  recipientsCount: 0,
  recipientsLoading: false,
  recipientsError: '',

  // Submit state for the broadcast itself.
  sending: false,
  sendError: '',
  lastSendResult: null,
};

export const fetchSmsRecipientsCount = createAsyncThunk(
  'sms/recipientsCount',
  async ({ target } = {}, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(API.vendors.smsRecipientsCount, {
        params: { target: target || 'all' },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(extractApiError(error));
    }
  }
);

export const sendBulkSms = createAsyncThunk(
  'sms/send',
  async ({ message, target }, { rejectWithValue }) => {
    try {
      const response = await apiClient.post(API.vendors.sendSms, {
        message,
        target: target || 'all',
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(extractApiError(error));
    }
  }
);

const smsSlice = createSlice({
  name: 'sms',
  initialState,
  reducers: {
    resetSendState(state) {
      state.sending = false;
      state.sendError = '';
      state.lastSendResult = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSmsRecipientsCount.pending, (state) => {
        state.recipientsLoading = true;
        state.recipientsError = '';
      })
      .addCase(fetchSmsRecipientsCount.fulfilled, (state, action) => {
        state.recipientsLoading = false;
        state.recipientsCount = action.payload?.count ?? 0;
      })
      .addCase(fetchSmsRecipientsCount.rejected, (state, action) => {
        state.recipientsLoading = false;
        state.recipientsError = action.payload || 'Xatolik';
      })
      .addCase(sendBulkSms.pending, (state) => {
        state.sending = true;
        state.sendError = '';
      })
      .addCase(sendBulkSms.fulfilled, (state, action) => {
        state.sending = false;
        state.lastSendResult = action.payload;
        // Inline Alert in SMSPage ko'rsatiladi — toast ortiqcha,
        // natijani sahifada qolgani yaxshi.
      })
      .addCase(sendBulkSms.rejected, (state, action) => {
        state.sending = false;
        state.sendError = action.payload || 'Xatolik';
        toast.error(action.payload || "SMS yuborishda xatolik");
      });
  },
});

export const { resetSendState } = smsSlice.actions;
export default smsSlice.reducer;
